/**
 * Defines the display order for parent categories in collection filters
 * Since the API doesn't support parent category ordering, we handle it on the frontend for now
 */
export const PARENT_CATEGORY_ORDER = ['Moisturizer', 'Cleanser', 'Sun Care', 'Masks'] as const;

/**
 * Gets the sort order for a parent category name
 * Returns a number that can be used for sorting (lower numbers appear first)
 * Categories not in the predefined order will appear after the ordered ones
 */
export const getCategoryOrder = (categoryName: string): number => {
  const index = PARENT_CATEGORY_ORDER.indexOf(categoryName as (typeof PARENT_CATEGORY_ORDER)[number]);
  return index === -1 ? PARENT_CATEGORY_ORDER.length : index;
};
